import { DI } from '@intigral/constant/config/DIContainer';
import { Container } from '../../../DIContainer';
import { GetAlowedChanelsUseCase } from './AllowedChanelsUseCase';
import { AllowedCountriesUseCase } from './AllowedCountriesUseCase';
import { AmazonAccountRecoveryUseCase } from './AmazonAccountRecoveryUseCase';
import { AvailablePackagesUseCase } from './AvailablePackagesUseCase';
import { GetAllSubscriptionTiersUseCase } from './GetAllSubscriptionTiersUseCase';
import { GetAllUseCase } from './GetAllUseCase';
import { GetAmazonActivationLinkUseCase } from './GetAmazonActivationLinkUseCase';
import { GetProfileMiniEpgChannelsUseCase } from './GetProfileMiniEpgChannelsUseCase';
import { GetTvodPricingTemplatesUseCase } from './GetTvodPricingTemplatesUseCase';
import { GetTvodUseCase } from './GetTVodsUseCase';
import { NetflixForgotAccountUseCase } from './NetflixForgotAccountUseCase';
import { PaymentSwitchGeneratePinUseCase } from './PaymentSwitchGeneratePinUseCase';
import { TvodPurchaseUseCase } from './TvodPurchaseUseCase';
import { PaymentSwitchVerifyPinUseCase } from './PaymentSwitchVerifyPinUseCase';
import { QitafGenerateOtpUseCase } from './QitafGenerateOtpUseCase';
import { QitafTvodGenerateOtpUseCase } from './QitafTvodGenerateOtpUseCase';
import { QitafTvodVerifyOtpUseCase } from './QitafTvodVerifyOtpUseCase';
import { QitafVerifyOtpUseCase } from './QitafVerifyOtpUseCase';
import { SubscribeUseCase } from './SubscribeUseCase';
import { TvodOtpGenerateUseCase } from './TvodOtpGenerateUseCase';
import { TvodOtpVerifyUseCase } from './TvodOtpVerifyUseCase';
import { PPVPurchaseGenerateOtpUseCase } from './PVVPurchaseGenerateOtpUseCase';
import { PPVPurchaseVerifyeOtpUseCase } from './PVVPurchaseVerifyOtpUseCase';
import { PPVPurchasePinUseCase } from './PVVPurchasePinUseCase';

export const initializeEntitlementUseCases = (container: Container) => {
    container.register(DI.USECASES.IAllowedChanelsUseCase, {
        useClass: GetAlowedChanelsUseCase,
    });
    container.register(DI.USECASES.IAllowedCountriesUseCase, {
        useClass: AllowedCountriesUseCase,
    });
    container.register(DI.USECASES.IAmazonAccountRecoveryUseCase, {
        useClass: AmazonAccountRecoveryUseCase,
    });
    container.register(DI.USECASES.IAvailablePackagesUseCase, {
        useClass: AvailablePackagesUseCase,
    });
    container.register(DI.USECASES.IGetAllSubscriptionTiersUseCase, {
        useClass: GetAllSubscriptionTiersUseCase,
    });
    container.register(DI.USECASES.IGetAllUseCase, {
        useClass: GetAllUseCase,
    });
    container.register(DI.USECASES.IGetAmazonActivationLinkUseCase, {
        useClass: GetAmazonActivationLinkUseCase,
    });
    container.register(DI.USECASES.IGetProfileMiniEpgChannelsUseCase, {
        useClass: GetProfileMiniEpgChannelsUseCase,
    });
    container.register(DI.USECASES.IGetTvodPricingTemplatesUseCase, {
        useClass: GetTvodPricingTemplatesUseCase,
    });
    container.register(DI.USECASES.IGetTvodUseCase, {
        useClass: GetTvodUseCase,
    });
    container.register(DI.USECASES.INetflixForgotAccountUseCase, {
        useClass: NetflixForgotAccountUseCase,
    });
    container.register(DI.USECASES.IPaymentSwitchGeneratePinUseCase, {
        useClass: PaymentSwitchGeneratePinUseCase,
    });
    container.register(DI.USECASES.IPaymentSwitchVerifyPinUseCase, {
        useClass: PaymentSwitchVerifyPinUseCase,
    });
    container.register(DI.USECASES.IQitafGenerateOtpUseCase, {
        useClass: QitafGenerateOtpUseCase,
    });
    container.register(DI.USECASES.IQitafTvodGenerateOtpUseCase, {
        useClass: QitafTvodGenerateOtpUseCase,
    });
    container.register(DI.USECASES.IQitafTvodVerifyOtpUseCase, {
        useClass: QitafTvodVerifyOtpUseCase,
    });
    container.register(DI.USECASES.IQitafVerifyOtpUseCase, {
        useClass: QitafVerifyOtpUseCase,
    });
    container.register(DI.USECASES.ISubscribeUseCase, {
        useClass: SubscribeUseCase,
    });
    container.register(DI.USECASES.ITvodOtpGenerateUseCase, {
        useClass: TvodOtpGenerateUseCase,
    });
    container.register(DI.USECASES.ITvodOtpVerifyUseCase, {
        useClass: TvodOtpVerifyUseCase,
    });
    container.register(DI.USECASES.ITvodPurchaseUseCase, {
        useClass: TvodPurchaseUseCase,
    });
    container.register(DI.USECASES.IPPVPurchaseGenerateOtpUseCase, {
        useClass: PPVPurchaseGenerateOtpUseCase,
    });
    container.register(DI.USECASES.IPPVPurchaseVerifyOtpUseCase, {
        useClass: PPVPurchaseVerifyeOtpUseCase,
    });
    container.register(DI.USECASES.IPPVPurchasePinUseCase, {
        useClass: PPVPurchasePinUseCase,
    });
};
